import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	pinnedCommentsHeader: {
		id: 'issue-view-activity-common.component.pinned-comments.pinned-comments-header',
		defaultMessage: 'Pinned comments',
		description: 'Header for the pinned comments section',
	},
	expandPinnedComments: {
		id: 'issue-view-activity-common.component.pinned-comments.expand-pinned-comments',
		defaultMessage: 'Expand pinned comments',
		description: 'Text for the expand pinned comments aria label',
	},
	collapsePinnedComments: {
		id: 'issue-view-activity-common.component.pinned-comments.collapse-pinned-comments',
		defaultMessage: 'Collapse pinned comments',
		description: 'Text for the collapse pinned comments aria label',
	},
});
